{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
SetTagView = require './set-tag-view'
PopOver = require 'app/scripts/views/lib/pop-over'
{ trackUe, Noun, Verb } = require '@trello/analytics'

module.exports = class AddTagView extends SetTagView
  onSubmit: (name) ->
    if name
      @model.tagList.create({ name }, wait: true)
      PopOver.popView()
      if featureFlagClient.get('remarkable.track-bc-features', false)
        trackUe
          category: Noun.BUSINESS_CLASS_FEATURE
          verb: Verb.CREATES
          directObj: Noun.COLLECTION
          context:
            organizationId: @model.id
            requiredBC: true

        Analytics.sendTrackEvent
          action: 'created'
          actionSubject: 'collection'
          containers:
            organization:
              id: @model.id
          source: 'teamScreen'
          attributes:
            isBCFeature: true
            requiredBC: true

    return

  viewTitleKey: 'add tag'
